async function requestJson(url, options = {}) {
  const response = await fetch(url, {
    ...options,
    headers: { Accept: 'application/json', ...(options.headers || {}) }
  });
  const data = await response.json();

  if (!response.ok) {
    const validationMessage = Object.values(data.errors || {}).flat().join(', ');
    throw new Error(data.error || validationMessage || 'Request failed');
  }
  return data;
}

export function fetchSearchOptions(optionsUrl, categoryId) {
  const url = new URL(optionsUrl, window.location.origin);
  if (categoryId) url.searchParams.set('category_id', categoryId);
  return requestJson(url);
}

export function fetchSearchResults(config, state, locale, signal) {
  let url;

  if (state.mode === 'extended' && state.query) {
    url = new URL(config.extendedSearchUrl, window.location.origin);
    url.searchParams.set('query', state.query);
    url.searchParams.set('lang', locale);
    url.searchParams.set('page', state.page);
    if (state.categoryId) url.searchParams.set('category_id', state.categoryId);
    if (state.classificationId && state.classificationId !== '0') {
      url.searchParams.set('classification_id', state.classificationId);
    }
  } else if (state.query) {
    url = new URL(config.freewordUrl, window.location.origin);
    url.searchParams.set('freeword', state.query);
    url.searchParams.set('page', state.page);
  } else {
    url = new URL(config.drinksUrl, window.location.origin);
    url.searchParams.set('classification_id', state.classificationId || '0');
    url.searchParams.set('page', state.page);
  }

  return requestJson(url, { signal });
}
